module.exports = __webpack_public_path__ + "img/pdf-brander-create-account.0e38f09a.png";